export default __webpack_public_path__ + "static/media/pic2.d599a6f7.jpg";